<div class="json-editor mat-elevation-z4">
  <p>Enter your body below,<br>
    if you want to use a variable value, surround it with % <br>
    for exemple: %sourceUri.User%
  </p>
  <textarea [(ngModel)]="jsonInput" rows="10" cols="50" (ngModelChange)="validateJSON()"></textarea>

  <div *ngIf="isValid" class="valid">
    Valid JSON
  </div>
  <div *ngIf="!isValid" class="invalid">
    Invalid JSON
  </div>
  <div class="dual-list-buttons">
    <ac-button class="list-button"
               (acClick)="beautifyJSON()"
               [buttonValue]="'Beautify Json'">
    </ac-button>
    <ac-button class="list-button"
               (acClick)="cancel()"
               [buttonValue]="'Cancel'">
    </ac-button>
    <ac-button class="list-button"
               (acClick)="applyJSON()"
               [ngDisabled]="!isValid"
               [buttonValue]="'Apply'">
    </ac-button>
  </div>
  <br>
</div>
